exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._3PUpeD3eSVQ_EzT_IO6HeC{margin:0 0 8px;margin:0 0 .5rem;font-size:1.25em;font-weight:400}._2NwkkfqBMUhaL9ZdfgC308{width:100%;border:1px solid #78909c;line-height:1.4;padding:.3em .5em;border-radius:.3em;margin-bottom:1em;font-size:1em}._2erELGrbxlcm0ryv7YiqBs{background-color:#ffd54f}._3RzObKX3H64W3_CFIR0jul{background-color:#f48f42}.gVEErGnDZ-WSa6GhxIhZ4{margin-bottom:0}._3dRwS7vUlUf0cDExAYRVcU{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}._1vdVGA0S4TqXNgluT0Tn7V,._2fuhYl9UEZv4UqlC0oTDWM{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto}._1vdVGA0S4TqXNgluT0Tn7V{margin-right:8px;margin-right:.5rem}._2fuhYl9UEZv4UqlC0oTDWM{margin-left:8px;margin-left:.5rem}", ""]);

// exports
exports.locals = {
	"Header": "_3PUpeD3eSVQ_EzT_IO6HeC",
	"Input": "_2NwkkfqBMUhaL9ZdfgC308",
	"Highlight": "_2erELGrbxlcm0ryv7YiqBs",
	"Active": "_3RzObKX3H64W3_CFIR0jul",
	"Footer": "gVEErGnDZ-WSa6GhxIhZ4",
	"Row": "_3dRwS7vUlUf0cDExAYRVcU",
	"FirstColumn": "_1vdVGA0S4TqXNgluT0Tn7V",
	"SecondColumn": "_2fuhYl9UEZv4UqlC0oTDWM"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&importLoaders=1!./~/cssnext-loader!./src/Highlighter.example.css
// module id = 199
// module chunks = 0